import React, { useContext, useEffect, useMemo, useState } from 'react'
import { DataContext } from '../../componets/ContextProvider'
import Hero from '../../componets/Hero'
import "./home.css"
import "../ListingPage/Listing.css"
import Testimonial from '../../componets/Testimonial'
import Support from '../../componets/Support'
import { FaBed, FaToilet } from 'react-icons/fa';
import founder from "../../images/founder3.jpeg"
import { NavLink } from 'react-router-dom'


const Home = () => {

  const [testimonialData, setTestimonialData] = useState([])

  const {
    list,
    getPropertyData,
    memorizedPropertiesDetails,
    getDocs,
    db,
    collection
  } = useContext(DataContext)

  const testimonialRef = collection(db, "testimonialData")

  useEffect(() => {
      const getTestmonialData = async () => {
        try{
          const data = await getDocs(testimonialRef)
          setTestimonialData(data.docs.map(doc => {
            return {
              ...doc.data(),
              id:doc.id
            }
          }))
        }
        catch(error){
          console.log(error.message)
        }
      }

    getTestmonialData()

    return () => getTestmonialData()
  }, [])

  const testimonial = useMemo(() => {
    return testimonialData.slice(0, 3).map((data) => {
      return (
        <Testimonial
          key={data.id}
          name={data.name}
          text={data.testimonial}
          img={data.image}
        />
      );
    });
  }, [testimonialData]);

  // console.log(list)
  return (
    <div>

      <Hero />

      <main>

      <section className="property-section">
        <h2 className="property-head">Exclusive Listing</h2>

        <div className="property-listing-container">
          {memorizedPropertiesDetails.slice(0, 4).map(data => {
              return <div
              key={data.id} 
              className="property-list"
              onClick={() => getPropertyData(data)}
              >
              <div className="property-img-container">
                <img src={data.images[0]} className="property-img" alt="real" />
              </div>
              <ul className="property-items">
                <li>{data.title}</li>
                <li>{`${data.location.city} ${data.location.state}`}</li>
                <li>&#x20A6;{data.price} million</li>
                <li><FaToilet />: {data.bathrooms} | <FaBed />: {data.bedrooms}</li>
              </ul>
            </div>
          })}
        </div >

        <NavLink to={"/listing"} className="see-more">See more listing <span>{">"}</span></NavLink>
      </section>

      <section className="founder-details">
          <div className="founder-img-container">
          <h4>Founder <small>aremudami_luxury</small></h4>
            <img src={founder} className="founder-img" alt="aremu-damilola" />
          </div>

          <div className="founder-about-container">
          <h4>Get to Know Me</h4>
            <span className="founder-about"> In the thriving luxury real estate market of Lagos, Nigeria, <b>Damilola Aremu</b> has earned an impeccable reputation as a highly skilled and reputable real estate agent. With an in-depth understanding of the Lagos state real estate market, Damilola is renowned for her unwavering integrity, loyalty, and utmost professionalism, making her one of the most trusted and admired agents in the region.


              <b> Damilola Aremu's</b> track record speaks for itself, having successfully facilitated numerous property sales and rentals to the utmost satisfaction of both enterprises and individuals alike. Her intimate knowledge of the Lagos real estate landscape has made her a sought-after expert among discerning clients seeking exquisite and discreet properties.

              Whether you are in search of sumptuous yet private luxury real estate or exclusive listings that cater to your unique preferences, <b>Damilola</b> is fully prepared to offer personalized guidance and showcase the finest properties that align with your needs.
            </span>
            <br />
            <a href="tel:+2348028016108">Contact Damilola</a>
          </div>
      </section>

      <div>
        <h2 className="testimonial-head"> Testimonials</h2>
        <h3 className="testimonial-title">Our past Client</h3>

        <div  className="testimonial-container">
        {testimonial}
        </div>
      </div>

      <Support />

      </main>
      
    </div>
  )
}

export default Home